// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ButtonV2__ButtonV2___21maE{background-color:#00336f;min-width:142px;font-weight:600;font-size:13px;border-radius:4px;padding:12px;color:white}.ButtonV2__ButtonV2Outline___2dv8k{background-color:transparent;min-width:auto;padding:0px;border:none;color:#00336f;display:flex;align-items:center}.ButtonV2__ButtonV2Outline___2dv8k:disabled{background-color:transparent !important;color:#00336f;opacity:0.6}.ButtonV2__ButtonV2Outline___2dv8k:hover{box-shadow:none;transform:none}.ButtonV2__ButtonV2___21maE:disabled{background-color:#a6a6a6;color:#595959}\n", ""]);
// Exports
exports.locals = {
	"ButtonV2": "ButtonV2__ButtonV2___21maE",
	"ButtonV2Outline": "ButtonV2__ButtonV2Outline___2dv8k"
};
module.exports = exports;
